import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Container from "../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import { mapToObjectDDL } from "../../common/mapper";
import { MANAGEMENT_CLAIM_TAB } from "./constant";
import ManagementClaimTab from "./managementClaimTab";

class ManagementClaim extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
      selectedCabang: null,
      userAccess: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  handleChangeState = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  fetchDataCabang = async () => {
    const { menuAccess, setError } = this.props;

    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: setError,
      menuName: "Management Claim",
      args: null,
    });
    if (res.ok) {
      const filteredData = res.data.data.filter((item) =>
        menuAccess.map((data) => data.idRefObj).includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          cabangOptions: filteredData.map((item) => ({
            ...item,
            label: item.namaDealer,
            value: item.kodeCabang,
          })),
          selectedCabang: {
            ...filteredData[0],
            label: filteredData[0].namaDealer,
            value: filteredData[0].kodeCabang,
          },
          userAccess: getUserAccess(menuAccess, filteredData[0].kodeCabang),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  render() {
    const { cabangOptions, selectedCabang, loading, userAccess } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin margin-bottom-15px">Cabang</p>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="selectedCabang"
              containerclassname="width width-280px"
              placeholder="Nama cabang hak akses"
              options={cabangOptions}
              value={selectedCabang}
              onChange={(value, { name }) =>
                this.handleChangeState(name, value)
              }
            />
          </FlexView>
          <Tabs>
            <TabList>
              {MANAGEMENT_CLAIM_TAB.map((item) => (
                <Tab key={`tab-header-${item.label}`}>{item.label}</Tab>
              ))}
            </TabList>
            {MANAGEMENT_CLAIM_TAB.map((item) => (
              <TabPanel key={`tab-${item.label}`}>
                <ManagementClaimTab
                  {...this.props}
                  tab={item.label}
                  tabCode={item.value}
                  userAccess={userAccess}
                  kodeCabangOptions={cabangOptions}
                  selectedCabang={selectedCabang}
                  onTriggerLoading={this.handleTriggerLoading}
                />
              </TabPanel>
            ))}
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ManagementClaim);
